<template>
  <div
    class="modal modal-flex modal-flex-box fade"
    id="modal-add-station-to-run"
    tabindex="-1"
    role="dialog"
    aria-labelledby="flexModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            &times;
          </button>
          <h4 class="modal-title" id="flexModalLabel">Add Station to Run</h4>
        </div>
        <ul
          class="list-data list-data-overflow has-multi-checkbox no-links m-t-none m-b-none"
        >
          <li class="data-heading sticky visible-md visible-lg">
            <div class="row">
              <div class="col-md-8">
                <p>Fire Station</p>
              </div>
              <div class="col-md-2">
                <p>Pickup</p>
              </div>
              <div class="col-md-2">
                <p>Delivery</p>
              </div>
            </div>
            <!-- /.row -->
          </li>

          <loading-spinner v-if="fetching"/>
          <li v-else-if="stations.length === 0" class="text-center">
            There are no stations pending pickup or delivery.
          </li>
          <li v-else v-for="station in stations" :key="station.id">
            <div class="form-check checkbox checkbox-success">
              <input
                :id="`station-${station.id}`"
                class="styled"
                :value="station.id"
                v-model="stationsSelected"
                type="checkbox"
              />
              <label :for="`station-${station.id}`"></label>
            </div>

            <div class="row">
              <div class="col-xs-12 col-md-8">
                <p>
                  <span class="data-label hidden-lg">Fire Station</span>
                  {{ station.name }} <br />
                  <span class="small text-muted">{{ station.address }}</span>
                </p>
                <p class="small strong"><font-awesome :icon="['fas', 'link']" v-if="station.linked_station" /> {{ station.linked_station }}</p>
              </div>
              <div class="col-xs-6 col-md-2">
                <p>
                  <span class="data-label hidden-lg">Pickup</span>
                  {{ station.pickup }}
                </p>
              </div>
              <div class="col-xs-6 col-md-2">
                <p>
                  <span class="data-label hidden-lg">Delivery</span>
                  {{ station.delivery }}
                </p>
              </div>
            </div>
            <!-- /.row -->
          </li>
        </ul>
        <!-- /.list-data -->
        <div class="modal-body" v-if="stationServerError">
          <div class="alert alert-danger">
            {{ stationServerError }}.
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Cancel
          </button>
          <async-button type="button" class="btn btn-green" :click="addStationsToRun" :disabled="stationsSelected.length === 0">
            Add to Run
          </async-button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import { get } from 'vuex-pathify'
import { http } from 'utils'
import BaseModal from 'components/BaseModal'

export default {
  extends: BaseModal,

  data () {
    return {
      fetching: false,
      stations: [],
      stationsSelected: [],
      stationServerError: null
    }
  },

  computed: {
    ...get('deliveryRuns', ['deliveryRun'])
  },

  methods: {
    async onModalShow () {
      this.fetching = true

      await this.getPendingStations()

      this.fetching = false
    },

    async getPendingStations () {
      const response = await http.get('/delivery-runs/pending-stations?exclude_eql_stations=true')

      this.stations = response.data.data
    },

    async addStationsToRun () {
      const { stationsSelected: stations, deliveryRun: { id } } = this

      try {
        const response = await http.post(`delivery-runs/${id}/stations`, { stations })

        this.$emit('added', response.data.data)

        this.stationsSelected = []

        this.hideModal()
      } catch (error) {
        // Handle errors with selected stations that can only be determined server side.
        if (error.response && error.response.status === 422) {
          const key = Object.keys(error.response.data.errors).find(value => value.match(/^stations\.\d+$/))

          if (key) {
            this.stationServerError = error.response.data.errors[key][0]
          }
        }
      }
    }
  }
}
</script>
